import { PATH } from 'common/constants';
import { selectCompanyJobsFilter } from 'redux/mapping/job/selectors';
import { selectFilter } from 'redux/marketPrice/selectors';

export const sharedPages = {
  jobs: PATH.TABLE_JOB_MAPPING,
  single: PATH.TABLE_PRICEJOB,
  mass: PATH.TABLE_PRICEJOB_MASS,
};

export const ActionTypes = {
  SET_SHARED_FILTER: 'SET_SHARED_FILTER',
};

export const setSharedFilter = (page) => (dispatch, getState) => {
  const filter = page === sharedPages.jobs ? selectCompanyJobsFilter(getState()) : selectFilter(getState());

  const sharedFilter = {
    plan: page === sharedPages.jobs ? [filter.plan] : filter.plan,
    jobSubFamily: filter.jobSubFamily,
    jobLevel: filter.jobLevel,
    search: filter.search,
    grade: filter.grade,
    companyJob: filter.companyJob,
  };
  dispatch({
    type: ActionTypes.SET_SHARED_FILTER,
    payload: sharedFilter,
    page,
  });
};
